import { Card, CardHeader, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { ContainerStyled } from '../../styles/styled/Reusable.styled';

export const TableContainer = ({
  children,
  cardTitle,
  showModal,
  fullWidth,
}) => {
  return (
    <Box>
      {fullWidth ? (
        <Card className="CradStyle">
          <CardHeader
            sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}
            title={
              <Typography variant="h4" component="h4">
                {cardTitle}
              </Typography>
            }
            action={
              <Typography variant="h6" component="h6" marginRight="20px">
                <Link to="#" onClick={() => showModal()}>
                  <i className="fas fa-plus fa-2x" />
                </Link>
              </Typography>
            }
          />
          <CardContent>{children}</CardContent>
        </Card>
      ) : (
        <ContainerStyled style={{ marginTop: '20px' }}>
          <Card
            sx={{
              maxWidth: fullWidth ? '100%' : 'auto',
            }}
          >
            <CardHeader
              sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}
              title={
                <Typography variant="h4" component="h4">
                  {cardTitle}
                </Typography>
              }
              action={
                <Typography variant="h6" component="h6" marginRight="20px">
                  <Link to="#" onClick={() => showModal()}>
                    <i className="fas fa-plus fa-2x" />
                  </Link>
                </Typography>
              }
            />
            <CardContent>{children}</CardContent>
          </Card>
        </ContainerStyled>
      )}
    </Box>
  );
};
